import { render, staticRenderFns } from "./FragmentPodcast.vue?vue&type=template&id=72ea625d"
import script from "./FragmentPodcast.vue?vue&type=script&lang=ts"
export * from "./FragmentPodcast.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports